/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CriticalNotificationSeverityEnum {
    Info = 'info',
    Warning = 'warning',
    Critical = 'critical'
}

export function CriticalNotificationSeverityEnumFromJSON(json: any): CriticalNotificationSeverityEnum {
    return CriticalNotificationSeverityEnumFromJSONTyped(json, false);
}

export function CriticalNotificationSeverityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriticalNotificationSeverityEnum {
    return json as CriticalNotificationSeverityEnum;
}

export function CriticalNotificationSeverityEnumToJSON(value?: CriticalNotificationSeverityEnum | null): any {
    return value as any;
}

